<div class="modal-confirm">
  <h2>{{ title|translate }}</h2>
  <h2>{{ subtitle|translate }}</h2>
  <div class="row">
    <div class="col-12">
      <button class="button button-yes" (click)="acceptButton()">{{ button|translate}}</button>
    </div>
  </div>
</div>
